import type { Result } from "../client";
import type { HttpClient } from "../client/api.client";
import { BaseService } from "../common/base-service";
import { transformKeys } from "../common/utils";
import type { CreateThreadMessageInput, ThreadMessages } from "../types";

export class MessageService extends BaseService {
	constructor(
		public client: HttpClient,
		private prefix = "/threads",
	) {
		super(client, prefix);
	}

	public async addMessageToThread(
		threadId: string,
		input: CreateThreadMessageInput,
	): Promise<Result<ThreadMessages>> {
		return this._client.post(`${this._prefix}/${threadId}/messages`, {
			data: input,
		});
	}

	public async getMessagesByThreadId(
		threadId: string,
		inputs = {},
	): Promise<Result<ThreadMessages>> {
		return this._client.get<ThreadMessages>(
			`${this._prefix}/${threadId}/messages`,
			transformKeys(inputs),
		);
	}

	public async getAllMessages(
		query: {
			after_timestamp?: string | null;
		} = {
			after_timestamp: null,
		},
	): Promise<Result<ThreadMessages>> {
		return this._client.get<ThreadMessages>(`/messages`, {
			query,
		});
	}
}
